import React from 'react';
import { CreditCardIcon, LockIcon, ShieldCheckIcon } from 'lucide-react';
import { heroStats, mockupUrl, pricingAnchor, projectSteps } from '../data/content';
import { Button } from './ui/Button';
import { Mark } from './ui/Section';
export function Hero() {
  return <section className="relative overflow-hidden bg-white px-4 pb-14 pt-9 md:pb-20 md:pt-14" data-id="element-122" data-mp="9igvb8esxojn">
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-123" data-mp="4jvup7vn12uo">
        <div className="mb-5 inline-flex rounded-full border border-sky-200 bg-sky-50 px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-wider text-sky-800 md:mb-6" data-id="element-124" data-mp="1285wpmvfbqls">
          Compra Digital Ya™
        </div>
        <h1 className="mx-auto max-w-4xl text-[2rem] font-black uppercase leading-[1.05] tracking-tight text-slate-900 md:text-[3.6rem]" data-id="element-125" data-mp="s9ghy2ytqm9r">
          🔨 Muebles Fáciles en Casa
        </h1>
        <p className="mt-3 text-sm font-extrabold uppercase tracking-wide text-sky-700 md:text-lg" data-id="element-126" data-mp="3d33eqyadctkr">
          5 tomos + 5 bonos · 50 proyectos completos · 400 páginas
        </p>

        <a href={pricingAnchor} className="group mx-auto my-6 flex w-full max-w-[300px] justify-center rounded-3xl focus:outline-none sm:max-w-[380px] md:my-8 md:max-w-[440px]" aria-label="Ver la oferta de Muebles Fáciles en Casa" data-id="element-127" data-mp="3j9kc5f0exnhp">
          <img className="mx-auto block w-full object-contain drop-shadow-2xl transition-transform duration-300 ease-out group-hover:scale-[1.015]" src={mockupUrl} alt="Mockup de Muebles Fáciles en Casa con sus 5 tomos y 5 bonos" data-id="element-128" data-mp="3e963buqzm9im" />
        </a>

        <h2 className="mx-auto max-w-4xl text-xl font-black leading-tight text-slate-900 md:text-[2.1rem]" data-id="element-129" data-mp="2qjv4wjx40r7n">
          Construí muebles <Mark data-id="element-130" data-mp="2vi55xb5imm16">útiles, lindos y prácticos</Mark> para distintos espacios de tu
          casa siguiendo cada proyecto paso a paso.
        </h2>

        <p className="mx-auto mt-5 max-w-2xl text-base font-semibold leading-relaxed text-slate-600 md:text-lg" data-id="element-131" data-mp="2hl9td8q22cgd">
          No necesitás diseñar un mueble desde cero ni calcular por tu cuenta cuánto tiene que medir
          cada pieza. Recibís proyectos completos con:
        </p>

        <ul className="mx-auto mt-4 flex max-w-3xl flex-wrap justify-center gap-2" data-id="element-132" data-mp="n9qjjcaquy90">
          {projectSteps.map(step => <li key={step} className="rounded-full border border-sky-200 bg-sky-50 px-3 py-1 text-xs font-bold text-sky-900 md:text-sm" data-id="element-133" data-mp="i9vqb23hxwks">
              {step}
            </li>)}
        </ul>

        <p className="mx-auto mt-5 max-w-2xl text-sm font-semibold text-slate-600 md:text-base" data-id="element-134" data-mp="161jcx7tq6lh9">
          Elegís qué querés construir, preparás las piezas y seguís el procedimiento.
        </p>

        <p className="mt-6 text-lg font-black uppercase text-slate-900 md:text-2xl" data-id="element-135" data-mp="x1w80c1sexjg">
          Tu próximo mueble empieza con un proyecto claro.
        </p>

        <div className="mt-6" data-id="element-136" data-mp="3lquhrx99on9a">
          <Button href={pricingAnchor} className="w-full md:w-auto" subtext="Mirá la oferta de lanzamiento antes de que cierre" data-id="element-137" data-mp="3hqu2kaecg816">
            Sí, quiero mis 50 proyectos →
          </Button>
        </div>

        <div className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] font-semibold text-slate-500 md:text-sm" data-id="element-138" data-mp="21b61vs3mqqk0">
          <span className="flex items-center gap-1" data-id="element-139" data-mp="2b0po97qjx2jm">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-sky-600" data-id="element-140" data-mp="2b2ai0v51khgf" />
            Garantía de 7 días
          </span>
          <span className="text-slate-300" data-id="element-141" data-mp="2fzj4h7x837nh">·</span>
          <span className="flex items-center gap-1" data-id="element-142" data-mp="2kydryn64xkdx">
            <LockIcon className="h-3.5 w-3.5 text-sky-600" data-id="element-143" data-mp="2l1028ukeudzu" />
            Pago seguro
          </span>
          <span className="text-slate-300" data-id="element-144" data-mp="2oye76a125zm1">·</span>
          <span className="flex items-center gap-1" data-id="element-145" data-mp="2tztvcayj8m8n">
            <CreditCardIcon className="h-3.5 w-3.5 text-sky-600" data-id="element-146" data-mp="2tx7o6cfk08qy" />
            Mercado Pago
          </span>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-3 md:mt-14 md:grid-cols-5" data-id="element-147" data-mp="zlaq40mlw4mx">
          {heroStats.map(([value, label], index) => <div key={label} className={`rounded-2xl border border-slate-200 bg-white p-4 text-center shadow-sm ${index === heroStats.length - 1 ? 'col-span-2 md:col-span-1' : ''}`} data-id="element-148" data-mp="4a2tti8kr5yk" data-mpi={index}>
              <p className="text-2xl font-black text-sky-600 md:text-3xl" data-id="element-149" data-mp="e8sbb9wk6oea">{value}</p>
              <p className="mt-1 text-[11px] font-bold leading-tight text-slate-600 md:text-sm" data-id="element-150" data-mp="9b09no643nww">
                {label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}